import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
  };

  const videosReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_videos_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_videos_success", (state,action) => {
        state.isLoading = false;
        state.Allvideos = action.payload.videos;
        state.pagination = action.payload.pagination;
        state.totalVideos=action.payload.totalVideos
      })
      .addCase("get_all_videos_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Fillter_videos_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_videos_success", (state,action) => {
        state.isLoading = false;
        state.FilterVideos = action.payload.videos;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_videos_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_video_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_video_success", (state,action) => {
        state.isLoading = false;
        state.videoData = action.payload;
      })
      .addCase("get_video_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      });
  });
  
  export default videosReducer;